<template>
  <div>
    <a-button type="primary" :style="{ margin: '0 0 24px 0' }" @click="add" v-if="roleId!=27">新增</a-button>
    <a-modal v-model="visible" centered title="添加商家账号" @ok="handleOk">
      <p>账号</p>
      <a-input v-model="form.loginNo"></a-input>
      <p>昵称</p>
      <a-input autoComplete="off" v-model="form.name"></a-input>
      <p>登录密码</p>
      <a-input-password autoComplete='new-password'  v-model="form.loginPwd"></a-input-password>
      <p>确认密码</p>
      <a-input-password v-model="Pwd"></a-input-password>
      <!--      <p>角色名称</p>-->
      <!--      <a-select-->
      <!--        v-model="form.role"-->
      <!--        default-value=""-->
      <!--        style="width: 120px"-->
      <!--        @change="handleChange"-->
      <!--      >-->
      <!--        <a-select-option-->
      <!--          v-for="(item, index) in xiala"-->
      <!--          :key="index"-->
      <!--          :value="item.id"-->
      <!--        >-->
      <!--          {{ item.roleName }}-->
      <!--        </a-select-option>-->
      <!--      </a-select>-->
      <p>手机号码</p>
      <a-input v-model="form.loginPhone"></a-input>
      <p>商家编号</p>
      <a-input v-model="form.merchantsNo"></a-input>
      <p>商家名称</p>
      <a-input v-model="form.merchantsName"></a-input>
      <p>商家地址</p>
      <a-input v-model="form.merchantsAddress"></a-input>
      <p>邮箱</p>
      <a-input v-model="form.emial"></a-input>
      <p>微信小程序 APPID</p>
      <a-input v-model="form.wxAppId"></a-input>
      <p>微信小程序 APP SECRET</p>
      <a-input v-model="form.wxAppSecret"></a-input>
    </a-modal>
    <a-modal v-model="visibletwo" centered title="编辑商家账号" @ok="handleOktwo">
      <p>账号</p>
      <a-input v-model="forms.loginNo"></a-input>
      <p>昵称</p>
      <a-input v-model="forms.name"></a-input>
      <p>新密码</p>
      <a-input-password v-model="newLoginPwd"></a-input-password>
      <!--      <p>角色名称</p>-->
      <!--      <a-select-->
      <!--        v-model="forms.role"-->
      <!--        default-value=""-->
      <!--        style="width: 120px"-->
      <!--        @change="handleChange"-->
      <!--      >-->
      <!--        <a-select-option-->
      <!--          v-for="(item, index) in xiala"-->
      <!--          :key="index"-->
      <!--          :value="item.id"-->
      <!--        >-->
      <!--          {{ item.roleName }}-->
      <!--        </a-select-option>-->
      <!--      </a-select>-->
      <p>商家编号</p>
      <a-input v-model="forms.merchantsNo"></a-input>
      <p>商家名称</p>
      <a-input v-model="forms.merchantsName"></a-input>
      <p>商家地址</p>
      <a-input v-model="forms.merchantsAddress"></a-input>
      <p>手机号码</p>
      <a-input v-model="forms.loginPhone"></a-input>
      <p>邮箱</p>
      <a-input v-model="forms.email"></a-input>
      <p>微信小程序 APPID</p>
      <a-input v-model="forms.wxAppId"></a-input>
      <p>微信小程序 APP SECRET</p>
      <a-input v-model="forms.wxAppSecret"></a-input>
    </a-modal>
    <a-modal v-model="visiblethree" centered width="1500px" :footer="null" title="门店列表">
      <storeManagementContent
        ref="iason"
        :formInline="merchantsFormInline"
      ></storeManagementContent>
    </a-modal>
    <a-modal v-model="visibleFour" centered width="1500px" :footer="null" title="模板消息列表">
      <tmplContent
        ref="iason2"
        :formInline="merchantsFormInline"
      ></tmplContent>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.orderNo"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <!-- 商品图片 -->
      <template slot="pic2" slot-scope="text, record">
        <img class="img2" :src="record.goodsRecord[0].goodsImg" alt=""/>
      </template>
      <template slot="goodsName" slot-scope="text, record">
        <span>{{ record.goodsRecord[0].goodsName }}</span>
      </template>
      <a-avatar slot="avatar" icon="user"/>
      <a-switch slot="memberStatus" default-checked @change="onChange"/>
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="edit(operate)">编辑</a>
        <a href="javascript:;" v-if="roleId!=27" @click="del(operate)">删除</a>
        <a href="javascript:;" v-if="roleId!=27" @click="merchants(operate)">查看门店</a>
        <a href="javascript:;" v-if="roleId!=27" @click="tmpl(operate)">模板消息</a>
      </template>
    </a-table>
  </div>
</template>
<script>
import {
  permissionsList,
  permissionsListXiala,
  permissionsAddAccount,
  permissionsEditAccount,
  permissionsDelAccount,
} from "@/api/homeApi.js";
import {message} from "ant-design-vue";
import storeManagementContent from "./storeManagementContent.vue";
import tmplContent from "./tmplContent.vue";

const columns = [
  {
    title: "管理员编号",
    dataIndex: "objId",
    // sorter: true,
    align: "center",
    scopedSlots: {customRender: "objId"},
  },
  {
    title: "账号",
    dataIndex: "loginNo",
    align: "center",
    scopedSlots: {customRender: "loginNo"},
  },
  {
    title: "昵称",
    dataIndex: "name",
    align: "center",
    scopedSlots: {customRender: "name"},
  },
  {
    title: "商家编号",
    dataIndex: "merchantsNo",
    align: "center",
    scopedSlots: {customRender: "merchantsNo"},
  },
  {
    title: "商家名称",
    dataIndex: "merchantsName",
    align: "center",
    scopedSlots: {customRender: "merchantsName"},
  },
  {
    title: "商家地址",
    dataIndex: "merchantsAddress",
    align: "center",
    scopedSlots: {customRender: "merchantsAddress"},
  },
  {
    title: "门店数量",
    dataIndex: "shopNum",
    align: "center",
    scopedSlots: {customRender: "shopNum"},
  },
  {
    title: "手机号",
    dataIndex: "loginPhone",
    align: "center",
    scopedSlots: {customRender: "loginPhone"},
  },

  {
    title: "邮箱",
    dataIndex: "email",
    // sorter: true,
    align: "center",
    // width: "10%",
    scopedSlots: {customRender: "email"},
  },

  {
    title: "角色名称",
    dataIndex: "roleName",
    // sorter: true,
    align: "center",

    // width: "15%",
    scopedSlots: {customRender: "roleName"},
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: {customRender: "operate"},
  },
];

export default {
  components: {
    storeManagementContent,
    tmplContent,
  },
  data() {
    return {
      merchantsFormInline: {
        categoryId: "",
        shopName: "",
        dutyPhone: "",
        merchantsId: "",
      },
      data: [],
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
      visibletwo: false,
      visiblethree: false,
      visibleFour: false,
      limit: 10,
      page: 1,
      goodsRecord: [],
      Pwd: "",
      form: {
        loginNo: "",
        loginPhone: "",
        loginPwd: "",
        name: "",
        role: 27,
        merchantsNo: "",
        merchantsName: "",
        merchantsAddress: "",
      },
      forms: {
        loginNo: "",
        loginPhone: "",
        loginPwd: "",
        name: "",
        role: 27,
        objId: "",
        merchantsNo: "",
        merchantsName: "",
        merchantsAddress: "",
        email: "",
        wxAppId: "",
        wxAppSecret: "",
      },
      roleId: 0,
      newLoginPwd: ""
    };
  },
  mounted() {
    this.roleId = sessionStorage.getItem("role");
    // if(this.roleId==27){
    //   this.form
    // }
    // this.getUserListDetails();
    this.getData();
    this.getpermissionsListXiala();
  },
  props: ["formInline"],
  methods: {
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    getpermissionsListXiala() {
      permissionsListXiala().then((res) => {
        this.xiala = res.data;
      });
    },
    handleTableChange(pagination, filters, sorter) {
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      this.formInline.page = this.pagination.current;
      // permissionsList({limit: 10, page: this.pagination.current,objId: this.formInline.objId}).then(
      //   (res) => {
      //     this.data = res.data;
      //     this.loading = false;
      //   });
      permissionsList(this.formInline).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    edit(row) {
      this.newLoginPwd = '';
      this.visibletwo = true;
      this.forms.objId = row.objId;
      this.forms.email = row.email;
      this.forms.role = 27;
      this.forms.name = row.name;
      this.forms.loginPwd = row.loginPwd;
      this.forms.loginPhone = row.loginPhone;
      this.forms.loginNo = row.loginNo;
      this.forms.merchantsNo = row.merchantsNo;
      this.forms.merchantsName = row.merchantsName;
      this.forms.merchantsAddress = row.merchantsAddress;
      this.forms.wxAppId = row.wxAppId;
      this.forms.wxAppSecret = row.wxAppSecret;
    },
    // 查询
    query() {
      this.loading = true;
      this.pagination.current = 1;
      this.formInline.page = 1;
      permissionsList(this.formInline).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        this.loading = false;
      });
    },
    del(row) {
      this.loading = true;
      permissionsDelAccount(row.objId).then((res) => {
        this.loading = false;
        this.getData();
        message.success(res.info);
      });
    },
    merchants(row) {
      this.visiblethree = true;
      this.merchantsFormInline.merchantsId = row.objId;
      this.$refs.iason.getData();
    },
    tmpl(row) {
      this.visibleFour = true;
      this.merchantsFormInline.merchantsId = row.merchantsNo;
      this.$refs.iason2.getData();
    },
    //
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //
    add() {
      this.visible = true;
      this.form = {
        role: 27
      };
    },
    handleOk() {
      console.log(this.form.loginPwd)
      if (this.form.loginPwd.trim() !== this.Pwd.trim()) {
        message.warning("两次输入的密码不一致");
      } else if (this.form.merchantsNo === "" || this.form.merchantsNo === null) {
        message.warning("商家编号不能为空");
      } else if (this.form.merchantsName === "" || this.form.merchantsName === null) {
        message.warning("商家名称不能为空");
      } else if (this.form.merchantsAddress === "" || this.form.merchantsAddress === null) {
        message.warning("商家地址不能为空");
      } else {
        permissionsAddAccount(this.form).then((res) => {
          this.visible = false;
          message.success(res.info);
          this.getData();
          this.form = {};
          this.Pwd = "";
          console.log(res)
        });
      }

    },
    handleOktwo() {
      if(this.newLoginPwd != ''){
        this.forms.loginPwd = this.newLoginPwd
      }
      if (this.forms.merchantsNo === "" || this.forms.merchantsNo === null) {
        message.warning("商家编号不能为空");
      } else if (this.forms.merchantsName === "" || this.forms.merchantsName === null) {
        message.warning("商家名称不能为空");
      } else if (this.forms.merchantsAddress === "" || this.forms.merchantsAddress === null) {
        message.warning("商家地址不能为空");
      } else {
        permissionsEditAccount(this.forms).then((res) => {
          this.visibletwo = false;
          message.success(res.info);
          this.getData();
        });
      }
    },
    getData() {
      permissionsList(this.formInline).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(this.data)
      });
    },
  },
};
</script>
<style scoped>
.img2 {
  width: 100px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/right/merchants/merchantsContent.vue